const SvgUpload = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M6.667 20H12v8h8v-8h5.333L16 10.667zM25.333 8H6.666V5.333h18.667z" />
  </svg>;
export default SvgUpload;